// extracted by mini-css-extract-plugin
module.exports = {"BreadCrumb":"FAQComponent_BreadCrumb__3CHvg","TagInput":"FAQComponent_TagInput__K0gNG"};